/// <reference path="../../Models/CertificateContainerModel.ts"/>
/// <reference path="../../Controls/CertificateGrid/CertificateGrid.ts"/>

module EEX.McEc {

    declare var apiUrl: string;

    export module Apps {
        import RevokeCertificateResult = McEc.Domain.RevokeCertificateResult;
        import WindowOptions = AppKitchen.UIHelper.Windows.WindowOptions;
        import UserInfo = AppKitchen.Api.Models.UserInfo;
        import Data = kendo.data;
        import CertificateModel = McEc.Domain.CertificateModel;
        import CertificateGridModel = McEc.Controls.CertificateGrid.CertificateGridModel;
        import CertificateFileRequest = McEc.Domain.CertificateFileRequest;
        import CertificateContainer = McEc.Models.CertificateContainer;
        import CertificateContainerModel = McEc.Models.CertificateContainerModel;
        import CertificateGridHelper = McEc.Controls.CertificateGrid.CertificateGridHelper;
        import CertificateState = McEc.Domain.CertificateState;

        // ReSharper disable once InconsistentNaming
        export interface CertificatesAppOptions extends AppKitchen.AppBaseOptions {
            certificateCreateDialog: AppKitchen.FrameManager.RoutedApp<CertificateCreateDialogOptions>,
            certificateDownloadDialog: AppKitchen.FrameManager.RoutedApp<CertificateDownloadDialogOptions>,
            authorityId: string,
        }

        export class CertificatesApp extends AppKitchen.AppBase<CertificatesAppOptions> {

            private gridModel: CertificateGridModel;
            private gridView: AppKitchen.Controls.Grids.GridView;

            private certificateCreateDialog: kendo.ui.Window;
            private certificateDownloadDialog: kendo.ui.Window;

            private certificateContainerModel: CertificateContainerModel;

            private userInfo: UserInfo;

            private containers: {
                list: HTMLElement,
            }

            private buttons: {
                createCertificate: JQuery,
            }

            public start() {
                this.certificateContainerModel = new CertificateContainerModel();
                this.reader();
                this.setContainer();
                this.loadAndCreateCertificateList();
                this.loadCurrentUser(() => {
                    this.setButtonAction();
                });
            }

            private reader(): void {
                AppKitchen.UIHelper.renderTemplateTo(this.el, McEc.Templates.Certificates);
            }

            private setContainer(): void {
                this.containers = {
                    list: this.$el.find(".eex-mcec-certificate-list-content-container")[0]
                }

                this.buttons = {
                    createCertificate: this.$el.find(".eex-mcec-create-certificate-btn")
                }
            }

            private loadCurrentUser(success: () => void) {
                AppKitchen.Data.Api.getUserInfo((userInfo: UserInfo) => {
                    this.userInfo = userInfo;
                        success();
                    },
                    (requestData, xhr) => {
                        AppKitchen.UIHelper.Notifications.notify(xhr.responseText, "warning");
                    });
            }

            private setButtonAction() {
                this.buttons.createCertificate.click(() => {

                    $.ajax({
                        dataType: "json",
                        type: "GET",
                        url: apiUrl + "/Document",
                        data: { filename: "messages", type: "McEc/ConfirmCreateNotification" },
                        success: (data: any) => this.showConfirmNotificationOrDialog(data),
                        error: (xhr: JQueryXHR, textStatus: string, errorThrown: string) => this.openCertificateCreateDialog(this.userInfo),
                        cache: false
                    });
                });
            }

            private showConfirmNotificationOrDialog(response: any) {
                var msg = JSON.parse(response);
                var localizedData = msg[kendo.culture().name];

                if (localizedData !== undefined && localizedData !== null) {
                    var validCert = this.certificateContainerModel.getCertificates().AsLinq<CertificateModel>().OrderByDescending(c => c.CreatedDate)
                        .FirstOrDefault(c => c.NotAfter > new Date(Date.now()) && c.NotBefore < new Date(Date.now()) && c.State === CertificateState.Issued);

                    if (validCert !== undefined && validCert !== null) {

                        var template = localizedData.join("").replace("<EXPIRY_DATE>", kendo.toString(validCert.NotAfter, "dd.MM.yyyy"));

                        AppKitchen.UIHelper.DialogBoxes.confirm(template,
                            () => this.openCertificateCreateDialog(this.userInfo),
                            { title: Strings.CertificateDialog_ConfirmCreateNew_Title });
                    } else {
                        this.openCertificateCreateDialog(this.userInfo);
                    }

                } else {
                    this.openCertificateCreateDialog(this.userInfo);
                }
            }

            private loadAndCreateCertificateList() {
                let gridConfig = CertificateGridHelper.getCertificateGridItem();
                this.gridModel = new CertificateGridModel(gridConfig, e => this.onDownload(e), e => this.onRevoke(e));

                this.gridView = new AppKitchen.Controls.Grids.GridView(this.gridModel,
                    this.containers.list,
                    {
                        fillHeight: true,
                        groupable: false,
                        sortable: true,
                        filterable: true,
                        noRecordsMessage: McEc.Strings.Grid_NoRecords,
                        lazyShow: { initial: 200, more: 80 },
                        headerTooltip: true,
                        initialSort: {
                            field: "CreatedDate",
                            dir: "desc"
                        },
                        templates: [
                            {
                                field: "CreatedDate",
                                template: (data) => {
                                    return this.parseDate(data["CreatedDate"]);
                                }
                            },
                            {
                                field: "NotBefore",
                                template: (data) => {
                                    return this.parseDate(data["NotBefore"]);
                                }
                            },
                            {
                                field: "NotAfter",
                                template: (data) => {
                                    return this.parseDate(data["NotAfter"]);
                                }
                            },
                            {
                                field: "State",
                                template: (data) => {
                                    return Helper.getLabelForStatus(data["State"]);
                                }
                            }
                        ]
                    });

                this.loadAndUpdateGridData();
            }

            private parseDate(date: string): string {
                if (this.isDateEmpty(date)) {
                    return "--";
                } else {
                    return kendo.toString(new Date(date), "G");
                }
            }

            private isDateEmpty(date: string): boolean {
                return date === "0001-01-01T00:00:00";
            }

            private updateGridData() {
                let certificates = this.certificateContainerModel.getCertificates();
                this.gridModel.set({ data: certificates });
            }

            private loadAndUpdateGridData() {
                new McEc.Data.Provider.CertificatesProvider().load()
                    .then(certificates => this.certificatesLoaded(certificates))
                    .fail(message => AppKitchen.UIHelper.Notifications.notify(message, "warning"));
            }

            private certificatesLoaded(certificates: CertificateModel[]) {
                this.certificateContainerModel.updateAll(certificates);
                this.updateGridData();
                setTimeout(() => {
                    this.loadAndUpdateGridData();
                }, 5000);
            }

            private onDownload(e: any) {
                let certificateKey = this.getCertificateKeyFromButtonClick(e);
                if (certificateKey) {
                    new McEc.Data.Provider.CertificateFileProvider().load({ CertificateKey: certificateKey })
                        .then(certificateFile => this.certificateFileDownloaded(certificateKey, certificateFile))
                        .fail(message => AppKitchen.UIHelper.Notifications.notify(message, "warning"));
                }
            }

            private certificateFileDownloaded(certificateKey: number, certificateFile: string) {
                let store: Pki.Store = null;
                let cc = this.certificateContainerModel.findByKey(certificateKey);
                if (cc) {
                    store = cc.store;
                }
                this.openCertificateDownloadDialog(this.userInfo, certificateKey, store, certificateFile);
            }

            private onRevoke(e: any) {
                let certificateKey = this.getCertificateKeyFromButtonClick(e);
                AppKitchen.UIHelper.DialogBoxes.yesNo(kendo.format(Strings.Grid_RevokeCertificate_Text, certificateKey),
                    () => this.revokeCertificate(certificateKey),
                    () => {},
                    Strings.Grid_RevokeCertificate);
            }

            private revokeCertificate(certificateKey: number) {
                if (certificateKey) {
                    new McEc.Data.Provider.CertificateRevokeProvider().revoke({ CertificateKey: certificateKey })
                        .then(result => this.showNotification(result))
                        .fail(message => AppKitchen.UIHelper.Notifications.notify(message, "warning"));
                }
            }

            private showNotification(result: RevokeCertificateResult) {
                if (result.Ok) {
                    AppKitchen.UIHelper.Notifications.notify(Strings.CertificatesListe_Revoke_Ok,
                        "success",
                        { closeAfter: 3000 });
                } else {
                    AppKitchen.UIHelper.Notifications.notify(`${Strings.CertificatesListe_Revoke_Error} ${result.ErrorMessage}`,
                        "warning",
                        { closeAfter: 3000 });
                }
            }

            private getCertificateKeyFromButtonClick(e: any): number {
                let row = e.currentTarget.parentElement.parentElement;
                let dataItem = this.gridView.grid.dataItem(row);
                let certificateKey = dataItem["Key"];
                return certificateKey;
            }

            private openCertificateCreateDialog(userInfo: UserInfo) {
                var appOptions = {
                    close: this.closeCertificateCreateDialog.bind(this),
                    userInfo: userInfo,
                    authorityId: this.options.authorityId
                };
                let title = McEc.Strings.CertificateDialog_CertificateCreateDialog_Title;
                var windowOptions: WindowOptions = {
                    title: title,
                    buttons: [
                        { name: "close", action: (window) => window.close() }
                    ],
                    modal: true,
                    easyClose: false,
                    width: "50em",
                    height: "30em"
                };

                // open window
                if (this.options.certificateCreateDialog) {
                    this.certificateCreateDialog = this.options.certificateCreateDialog.startInWindow(windowOptions, appOptions);
                }
            }

            private closeCertificateCreateDialog(certificateKey: number, store: Pki.Store, certificateFile: string) {
                if (this.certificateCreateDialog) {
                    this.certificateCreateDialog.close();
                    if (certificateKey && store && certificateFile) {
                        this.certificateContainerModel.updateByKey(certificateKey, store, certificateFile);
                        this.updateGridData(); 
                    }
                }
            }

            private openCertificateDownloadDialog(userInfo: UserInfo, certificateKey: number, store: Pki.Store, certificateFile: string) {
                var appOptions = {
                    userInfo: userInfo,
                    authorityId: this.options.authorityId,
                    certificateKey: certificateKey,
                    store: store,
                    certificateFile: certificateFile,
                    close: this.closeCertificateDownloadDialog.bind(this)
                };
                var windowOptions: WindowOptions = {
                    title: McEc.Strings.CertificateDialog_CertificateDownloadDialog_Title,
                    buttons: [
                        { name: "close", action: (window) => window.close() }
                    ],
                    modal: true,
                    easyClose: false,
                    width: "50em",
                    height: "30em"
                };

                // open window
                if (this.options.certificateDownloadDialog) {
                    this.certificateDownloadDialog = this.options.certificateDownloadDialog.startInWindow(windowOptions, appOptions);
                }
            }

            private closeCertificateDownloadDialog(certificateKey: number, store: Pki.Store, certificateFile: string) {
                if (this.certificateDownloadDialog) {
                    this.certificateDownloadDialog.close();
                    if (certificateKey && store && certificateFile) {
                        this.certificateContainerModel.updateByKey(certificateKey, store, certificateFile);
                        this.updateGridData();
                    }
                }
            }
        }
    }
}